// extracted by mini-css-extract-plugin
module.exports = {"disc":"e_dl","accent":"e_el","empty":"e_fl","s32":"e_gl","s36":"e_hl","s44":"e_il","s56":"e_jl","s72":"e_kl"};